exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TableUsers table{width:100%}.TableUsers table button{background:none}.TableUsers table img{width:16px}.TableUsers table td,.TableUsers table th{padding:7px;border-bottom:1px solid #ccc}.TableUsers table th{color:#00adff}.TableUsers table td{cursor:pointer}.TableUsers table tr.new-address-user{cursor:default}.TableUsers table tr.new-address-user input{border:1px solid #ccc;padding:5px}.TableUsers table tr.new-address-user td{border:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/QbmPage/QbmUserBooks/components/TableUsers/style.scss
// module id = 4500
// module chunks = 0